import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_panel/zadania/tematyczne/')({
  beforeLoad: () => {
    throw redirect({ to: '/zadania/projekty' })
  },
})
